/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { IconTitle } from '../../../../components';
import { usePersonContext } from '../../../../contexts/PersonContext';
import { Person } from '../../../../entities';
import { clone } from '../../../../utils/helpers';
import Form from './components/Form';
import useStyles from './styles';
import { NewPerson, usePersons, useStorage } from '../../../../hooks';

export const BasicData = (): JSX.Element => {
  const styles = useStyles();
  const { person: loadedPerson, loading } = usePersonContext();
  const [person, setPerson] = useState<Person>(loadedPerson || ({} as Person));
  const [fileToUpload, setFileToUpload] = useState<File | null>();
  const { enqueueSnackbar } = useSnackbar();
  const repository = usePersons();
  const navigate = useNavigate();
  const storage = useStorage();

  useEffect(() => {
    setPerson(clone(loadedPerson || ({} as Person)));
  }, [loadedPerson]);

  const handleFetchImage = async (value: Person) => {
    if (fileToUpload === undefined) return;

    let photoUrl: string | null = null;

    if (fileToUpload) {
      const extension = fileToUpload.name.split('.').pop();
      const imageName = new Date().toISOString();

      photoUrl = await storage.upload(`/persons/${value.id}/${imageName}.${extension}`, fileToUpload);
    }

    if (photoUrl !== value.photoUrl) {
      await repository.update({ photoUrl, id: value.id });
    }
  };

  const handleCreate = async (value: NewPerson) => {
    const result = await repository.create(value);
    await handleFetchImage(result);
    navigate(`/persons/${result.id}/`);
  };

  const handleUpdate = async (value: Person) => {
    await repository.update(value);
    await handleFetchImage(person);
  };

  const handleSubmit = async (value: Person | NewPerson) => {
    try {
      if ('id' in value) {
        await handleUpdate(value);
      } else {
        await handleCreate(value);
      }

      enqueueSnackbar('Usuário salvo com sucesso', { variant: 'success' });
    } catch (err) {
      enqueueSnackbar('Não foi possível salvar o usuário', { variant: 'error' });
    }
  };

  const handleUpload = (file: File | null) => {
    setFileToUpload(file);
  };

  if (loading) {
    return <></>;
  }

  return (
    <div className={styles.container}>
      <IconTitle title="Dados básicos" />
      <Form person={person} onSubmit={handleSubmit} fileToUpload={fileToUpload} handleUpload={handleUpload} />
    </div>
  );
};

export default BasicData;
